import React, {useState, useEffect} from 'react';
import useWindowDimensions from '../../utils/useWindowDimensions';
import classes from './ContentDetails.module.scss';
import Button from '../UI/Button/Button';
import GooglePay from '../GooglePay/GooglePay';
import axios from '../../axios-instance';
import AppleWallet from '../../images/Add_to_Apple_Wallet_rgb_US-UK.svg';
import ResponsiveDialog from '../UI/ResponsiveDialog/ResponsiveDialog';
import Scratcher from '../Scratcher/Scratcher';
import OfferDetails from './OfferDetails/OfferDetails';
import Loader from './../UI/Loader/Loader';
import EmailSubmit from './../EmailSubmit/EmailSubmit';

let styles = {
    dateColor: {
        color: '#22A033'
    }
}
const ContentDetails = props => {
    const { height, width } = useWindowDimensions();
    const [showLoading, setShowLoading] = useState(true);
    const [showTerms, setShowTerms] = useState(false);
    const [showPass, setShowPass] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [downloadLink, setDownloadLink] = useState('');
    const [action, setAction] = useState('');
    const [imageError, setImageError] = useState(false)
    const [showOfferDetails, setShowOfferDetails] = useState(false);
    const [hasTimer, setHasTimer] = useState(false);
    const [limitSeconds, setLimitSeconds] = useState(0);
    const [hideAt, setHideAt] = useState(0);
    const [running, setRunning] = useState(false);
    const [expDate, setExpDate] = useState(0);
    const [expired, setExpired] = useState(null);
    const [distance, setDistance] = useState(0);
    const [displayForm, setDisplayForm] = useState(1);

    const { content, description } = props;

    const getWindowDimensions = () => {
        let div = document.getElementById('responsiveContentContainer');    
        if (div) {
            let w = div.offsetWidth;
            let h = div.offsetHeight
            return {
                w,
                h
            };
        }
    }
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    let attachedClasses = [classes.ContentPreview, classes.Close];

    let actionClasses = [classes.Actions];

    const udateTerms = (bool) =>  {
        setShowTerms(bool)
    }

    useEffect(() => {

        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        console.log('Content Details...');
        setHasTimer(content?.redemption?.timer?.enabled ?? false);
        setLimitSeconds(content?.redemption?.timer?.limit ?? 0);
        setHideAt(Number(content?.redemption?.status?.hide_at) * 1000 ?? 0);
    }, [content]);

    useEffect(()=> {
        let countInterval;
        if (running) {
            const countDownDate = new Date(expDate).getTime();
            countInterval = setInterval(() => {
                const now = new Date().getTime();
                const distance = countDownDate - now;
                setDistance(distance)
                if (distance < 0) {
                    setExpired(true);
                    clearInterval(countInterval);
                } else {
                    setExpired(false)
                }
            }, 1000);
            return () =>  {
                setRunning(false);
                setExpDate(0)
                clearInterval(countInterval);
            }
        } else {
            setRunning(false);
            setExpDate(0)
            clearInterval(countInterval);
        }
    }, [expDate, running])

    const createMarkup = () => {
        return {__html: description};
    }

    useEffect(() => {
        udateTerms(props.hasTerms)
    }, [props.hasTerms]) 

    useEffect(() => {
        updatePass(props.androidPass)
    }, [props.androidPass]) 

    useEffect(() => {
        if (props.showDownload) {
            let urlArr = new URL(props.buyOnline).search.split('&');
            let str = urlArr[0].split('?action=').join('')
            setAction(str.charAt(0).toUpperCase() + str.slice(1))
            if (props.isMobile) {
                props.isIphone ? setDownloadLink(decodeURIComponent(urlArr[1].split('ios=').join(''))) : setDownloadLink(decodeURIComponent(urlArr[2].split('android=').join('')));
            } else {
                props.device.os_name === "Mac OS" ? setDownloadLink(decodeURIComponent(urlArr[1].split('ios=').join(''))) : setDownloadLink(decodeURIComponent(urlArr[2].split('android=').join('')))
            }
        }
    }, [props.showDownload, props.buyOnline, props.isMobile, props.isIphone, props.device]) 

    useEffect(() => {
        if (props.scratcher === true || props.scratcher === null) {
            toggleLoading(true);
        } else {
            updateStatus(1);
            //toggleLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.scratcher]) 

    useEffect(()=>{
        const params = new URLSearchParams(window.location.search);
        if(params.get('display_form')) {            
            setDisplayForm(parseInt(params.get('display_form')));
        }else if (props.content.id === 6970) {
            setDisplayForm(0);
        }
        
    });

    const updatePass = (bool) =>{
        setShowPass(true)
    }

    const toggleLoading = (bool) => {
        setShowLoading(bool);
    }

    const onTerms = () => {
        setShowModal(!showModal)
    }
    
    // eslint-disable-next-line no-undef
    const updateStatus = async status => {

        if(props.content.type === 'prize' && status === 1) {
            const params = new URLSearchParams(window.location.search);
            if(params.has('subscription_id')) {
                const payload = {
                    subscription_id : params.get('subscription_id'),
                    content_id : props.content.id
                }
                sendPrizeNotification(payload);
            }
        }

        try {
          const uri = `/device/${props.device.uuid}/content/${props.content.id}?status=${status}`;
          const res = await axios.put(
            uri,
            {},
            {
              headers: {
                'Content-Type': 'application/json',
                'x-device-uuid': `${props.device.uuid}`
              }
            }
          );
          if (res && res.status === 200) {
            if (res.data && res.data.message) {
            //   console.log('STATUS: ', status + ' ', res.data.message);
            }
          }
        } catch (err) {
        console.error('Error: ', err);

        }
    };    

    const postEvent = async(event) => {

        try {
          const res = await axios.post(`/event`, event, {
            headers: {
              'x-device-uuid': `${props.device.uuid}`,
            }
          });
          if (res && res.data) {
            console.log('Event tracked', res.data);
          }
        } catch(err) {
          console.error('Error: ', err);
        }
    }

    const sendPrizeNotification = async(payload) => {

        try {
            const res = await axios.post(`/tpn/oikos/send-prize-notification`, payload, {
              headers: {
                'x-device-uuid': `${props.device.uuid}`,
              }
            });
            if (res && res.data) {
              console.log(res.data);
            }
          } catch(err) {
            console.error('Error: ', err);
          }
    }

    const getAppleWalletPasskit = async () => {
        let root = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_ACTV8_API_ROOT_DEV : process.env.REACT_APP_ACTV8_API_ROOT_PROD;
        let key = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_ACTV8_API_KEY_DEV : process.env.REACT_APP_ACTV8_API_KEY_PROD;

        try {
          const uri = `${root}/device/${props.device.id}/content/${props.content.id}/applepass`;
          fetch(uri, {
            headers: {
              'x-api-key': `${key}`,
              'x-api-version': `4.4`,
              'Accept': 'application/vnd.apple.pkpass',
              'x-device-uuid': `${props.device.uuid}`
            }
          }).then(response => {            
            updateStatus(2);
            response.blob().then(blob => {
              let url = window.URL.createObjectURL(blob);
              let a = document.createElement('a');
              a.href = url;
              a.download = 'pass.pkpass';
              a.click();
            });
          });
        } catch (err) {
          console.error('Error: ', err);
        }
    };

    const createAppleWalletPasskit = async () => {
        try {
          const uri = `/device/${props.device.id}/content/${props.content.id}/applepass`;
          const res = await axios.post(
            uri,
            {"forward_params":props.forwardParams},
            {
              headers: {
                'Accept': 'application/vnd.apple.pkpass',
                'x-device-uuid': `${props.device.uuid}`
              }
            }
          );
          if (res && res.data) {
            getAppleWalletPasskit();
          }
        } catch (err) {
          console.error(err);
        }
    };

    const onBuyNow = () => {
        let url = props?.content?.redemption?.url ?? '';
        // Appends forward params (i.e. macros) based on env setting 
        if(url !== '' && process.env.REACT_APP_FORWARD_PARAMS === 'true') {
            url += url.indexOf('?') > -1 ? '&' : '?';
            url += props.forwardParams;
        }
        window.open(url,'_blank');
        updateStatus(5)
    }

    const onClickThrough1 = () => {
        let url = props?.clickThroughBtn1?.value ?? '';
        handleClickThrough(url);
    }

    const onClickThrough2 = () => {
        let url = props?.clickThroughBtn2?.value ?? '';
        handleClickThrough(url);
    }

    const onURLClickThrough = () => {
        let url = props.content.url;
        handleClickThrough(url);
    }

    const handleClickThrough = (url) => {
        const event = {
            category: "End-User Action",
            subcategory: "Content Button",
            action: "Click-Through",
            label: url,
        } 

        event.client_id = props.content?.client_id?? null;
        event.campaign_id = props.content?.pivot?.campaign_id?? null;
        event.trigger_id = props.content?.pivot?.trigger_id?? null;
        event.content_id = props.content?.pivot?.content_id?? null;

        updateStatus(5)
        postEvent(event);
        window.open(url,'_blank');

    }

    const onDownloadApp = () => {
        window.open(downloadLink, "_blank")
    }
    const onImageError = () => {
        setImageError(true);
        toggleLoading(false);
    }
    const onViewOfferDetails = (type) => {
        setShowOfferDetails(true);
        if (type === 'instore' && !hasTimer) {
            updateStatus(4)
        }
    }
    const onCloseOfferDetails = () => {
        setShowOfferDetails(!showOfferDetails);
    }
    
    if (props.content.redemption && props.content.redemption.method === 3) {
        actionClasses.push(classes.MoreBtnSpace)
    }
    let terms;
    let buyInStore = '';

    if (props.content.redemption && (props.content.redemption.method === 2 || props.content.redemption.method === 3)) {
        buyInStore = (
            <Button
                onClick={() => onViewOfferDetails('instore')}
                btnText={props?.content?.type === 'prize'? 'Redeem Prize': props.buyInStoreText}
                className={classes.Button}>
            </Button>
        )
    }

    let gpay;

    if (props.open) {
        attachedClasses = [classes.ContentPreview, classes.Open];
    }
    if (props.hasTerms || showTerms) {
        terms = (
            <div className={classes.Terms} onClick={onTerms}>
                Terms & Conditions
            </div>
        )
    }
    if (props.date) {
        let date = props.date.split(' ');
        styles = {
            dateColor: {
                color: props.date === 'Expired' ? '#A02222' : (date[0] === 'in' && Number(date[1]) <= 3 && date[2] === 'days') || date[2] === 'day' ? '#FFA000' : '#22A033'
            }
        }
    }
    
    if (showPass === true) {
        var winNav = window.navigator;
        let isIOSChrome = winNav.userAgent.match("CriOS");
        if (props.isMobile && props.isIphone && props.applePass && !isIOSChrome) {
            gpay = (
                <img
                    src={AppleWallet}
                    alt='Add to Apple Wallet'
                    className={classes.WalletButton}
                    onClick={() => createAppleWalletPasskit()}
                    />
            )
        } else {
            gpay = (
                <GooglePay
                    onSaveToWallet={() => updateStatus(2)}
                    jwt={props.jwt} /> 
            )
        }

    }

    const offerComp = (
        <div className={classes.ContentContainer} id={'responsiveContentContainer'} style={{height: '737px'}}>
            <ResponsiveDialog
                open={showModal}
                onClose={() => onTerms()}>
                {props.terms}
            </ResponsiveDialog>
            <ResponsiveDialog 
                offerDetailsModal={true}
                open={showOfferDetails}
                onClose={()=>onCloseOfferDetails()}>
                <OfferDetails
                    onUpdateStatus={updateStatus}
                    brand={props.brand}
                    content={props.content}
                    hasTimer={hasTimer}
                    hideAt={hideAt}
                    limitSeconds={limitSeconds}
                    onSetExpDate={(date)=> setExpDate(date)}
                    distance={distance}
                    running={running}
                    onSetRunning={(bool)=>setRunning(bool)}
                    expired={expired}
                    onClose={() => onCloseOfferDetails()}
                    onBuyNow={onBuyNow} />                        
            </ResponsiveDialog>
            <div>
                <section className={classes.HeroContainer}>
                    { imageError ? <div className={classes.FallbackHero}><div>Image Loading Error</div></div> : ''}
                    <div className={classes.HeroImage}>
                        { !imageError ?
                            <img
                                src={props.hero}
                                alt={props.hero}
                                onLoad={() => toggleLoading(false)}
                                onError={onImageError}/> : ''
                        }                            
                    </div>
                </section>
                <div className={classes.ContentItems}>
                    <div className={classes.Title}>
                        {props.content.display_name}
                    </div>
                    <div className={classes.SubContent}>
                        <div className={classes.Brand}>
                            From {props.brand}
                        </div>
                        {/* <div style={styles.dateColor} className={classes.Date}>
                        {props.date !== 'Expired' ? 'Expires' : ''} {props.date}
                        </div> */}
                        <div className={classes.PayBtn}>
                            <div className={classes.BtnCol}>{gpay}</div>
                        </div>
                    </div>
                    <div className={classes.Description}>
                    <div dangerouslySetInnerHTML={createMarkup()}></div>
                        {terms}
                    </div>               
                </div>
            </div>
            
            { 
            <div className={actionClasses.join(' ')}>
                {buyInStore}
                {props.buyOnline && props.buyOnline !== "" && !props.showDownload && !props.clickThroughBtn1 ? <Button
                    className={classes.Button}
                    href={props.content.redemption && props.content.redemption !== null && props.content.redemption.url ? props.content.redemption.url : ''}
                    target="_blank"
                    onClick={onBuyNow}
                    btnText={props.buyNowText}>
                </Button> : ''}

                {props.clickThroughBtn1 ? <Button
                    className={classes.Button}
                    href={props.clickThroughBtn1.value ? props.clickThroughBtn1.value : ''}
                    target="_blank"
                    onClick={onClickThrough1}
                    btnText={props.clickThroughBtn1.label ? props.clickThroughBtn1.label : ''}
                    backgroundColor={"black"} 
                    >
                </Button> : ''}

                {props.clickThroughBtn2 ? <Button
                    className={classes.Button}
                    href={props.clickThroughBtn2.value ? props.clickThroughBtn2.value : ''}
                    target="_blank"
                    onClick={onClickThrough2}
                    btnText={props.clickThroughBtn2.label ? props.clickThroughBtn2.label : ''}
                    backgroundColor={"black"}                     
                    >
                </Button> : ''}

                {props.showDownload && downloadLink && downloadLink !== "" ? 
                    <Button
                        href={downloadLink}
                        target="_blank"
                        className={classes.Button}
                        btnText={action}
                        onClick={onDownloadApp}>
                    </Button> : ''
                }
            </div>
            }
        </div>
    )

    const messageComp = (
        <div className={classes.ContentContainer} id={'responsiveContentContainer'} style={{backgroundColor:"black", height: props.scratcher ? '737px' : '844px', minHeight: !props.scratcher ?? '737px'}}>
            <div>
            <section className={classes.HeroContainer} style={{backgroundColor:"black", color:"white"}}>
                    <div className={classes.HeroImage}>
                            <img
                                src={props.hero}
                                alt={props.hero}
                                style={{width: '100%'}}
                                onLoad={() => toggleLoading(false)}
                                onError={onImageError}/>
                    </div>
                </section>
                <div className={classes.ContentItems} style={{minHeight: 'auto', maxHeight: props.scratcher ? '300px' : 'none'}}>
                    <div className={classes.Title} style={{color:"white", lineHeight: "40px", fontSize: "30px", fontWeight:"800", marginTop:"30px", marginBottom:"30px"}}>
                        {props.content.name}
                    </div>
                    <div style={{color:"white", lineHeight: "28px", fontSize: "18px", marginBottom:"30px", textAlign: 'center'}}>
                        {props.content.display_name}
                    </div>
                    
                    {props.content.name === 'Almost game time!'? 
                        <div className={classes.Description} style={{color:"white", lineHeight: "28px", fontSize: "20px", marginTop:"30px", paddingBottom:"30px", fontWeight:"600"}}>
                            Come back 1/25/23 to get your offer!
                        </div>               
                    : ''} 
                </div>

            </div>        
        </div>
    )

    const loserMessageComp = (
        <div className={classes.ContentContainer} id={'responsiveContentContainer'} style={{backgroundColor:"black", height: props.scratcher ? '737px' : '844px', minHeight: !props.scratcher ?? '737px'}}>
            <div>
                <section className={classes.HeroContainer} style={{backgroundColor:"black", color:"white"}}>
                    <img src={props.hero} alt={'Hero'} style={{width: '100%'}}/> 
                </section>
                <div className={classes.ContentItems} style={{minHeight: 'auto', maxHeight: props.scratcher ? '300px' : 'none'}}>
                    <div className={classes.Title} style={{color:"white", lineHeight: "40px", fontSize: "30px", fontWeight:"800", marginTop:"30px", marginBottom:"30px"}}>
                        {props.content.name}
                    </div>
                    <div style={{color:"white", lineHeight: "28px", fontSize: "18px", marginBottom:"30px", textAlign: 'center'}}>
                        {props.content.display_name}
                    </div>
                    <div className={classes.Description} style={{color:"white", lineHeight: "28px", fontSize: "20px", marginTop:"30px", paddingBottom:"30px", fontWeight:"600"}}>
                        Scan Again Tomorrow
                    </div>               
                </div>
            </div>        
        </div>
    )

    const prizeComp = (
        <div className={classes.ContentContainer} id={'responsiveContentContainer'} style={{backgroundColor:"black", height: props.scratcher ? '737px' : '844px', minHeight: !props.scratcher ?? '737px'}}>
            <div>
                <section className={classes.HeroContainer} style={{backgroundColor:"black", color:"white"}}>
                    <img src={props.hero} alt={'Hero'} style={{width: '100%'}}/> 
                </section>
                <div className={classes.ContentItems} style={{minHeight: 'auto', maxHeight: props.scratcher ? '300px' : 'none'}}>
                    <div className={classes.Title} style={{color:"white", lineHeight: "40px", fontSize: "30px", fontWeight:"800", marginTop:"30px", marginBottom:"30px"}}>
                        {props.content.display_name}
                    </div>

                    <div style={{color:"white", lineHeight: "28px", fontSize: "20px", textAlign: 'center', fontWeight:'600'}} dangerouslySetInnerHTML={createMarkup()}></div>
                    <div className={classes.Description} style={{color:"white", lineHeight: "28px", fontSize: "18px", marginTop:"30px", paddingBottom:"30px"}}>
                        We will contact you via email so you can claim your prize!
                    </div>               
                </div>
            </div>        
        </div>
    )

    const urlComp = (
        <div className={classes.ContentContainer} id={'responsiveContentContainer'}>
            <div>
                <section className={classes.HeroContainer}>
                    <img src={props.hero} alt={'Hero image'} style={{width: '100%'}}/> 
                </section>

                {!displayForm ?
                    <div className={classes.ContentItems}>
                        <div className={classes.Title} style={{lineHeight: "40px", fontSize: "30px", fontWeight:"800", marginTop:"30px", marginBottom:"30px"}}>
                            {props.content.display_name}
                        </div>
                        <div style={{lineHeight: "28px", fontSize: "18px", marginBottom:"60px", textAlign: 'center'}} dangerouslySetInnerHTML={createMarkup()}></div>
                        <Button className={classes.Button} href={props.content.url} onClick={onURLClickThrough} btnText={"Oikos.com"}/>
                    </div> :
                    <EmailSubmit 
                        description={props.content.description}
                        redirect={props.content.url} 
                        device_uuid={props.device.uuid}
                        source_type={props.content.type} 
                        source_id={props.content.id}
                        />
                }

            </div>        
        </div>
    )

    const contentComp = (
        <div>
        {props.content.type === 'offer' && (
            <div>{offerComp}</div>
        )}
        {props.content.type === 'url' && (
            <div>{urlComp}</div>
        )}
        {props.content.type === 'message' && (
            (props.content.name === 'You came up just short of the goal line!') ? <div>{loserMessageComp}</div> : <div>{messageComp}</div> ) 
        }
        {props.content.type === 'prize' && (
            <div>{prizeComp}</div>
        )}
        </div>
    )

    return (
        <div className={attachedClasses.join(' ')} style={{maxHeight: '736px'}}>
            {/* {showLoading ? (
                <div style={{height: height, width: width, maxHeight: '736px', maxWidth: '414px', paddingTop: '60px'}} className={classes.ContentPreviewLoading}>
                    <Loader />
                </div> ) : ''
            } */}
            { props.scratcher ?
                <Scratcher
                    onUpdateStatus={updateStatus}
                    onToggleLoading={toggleLoading}
                    overlay={props.scratcherOverlayImage}
                    height={height}
                    width={width}
                    windowDimensions={windowDimensions}> 
                        {contentComp}
                </Scratcher> : contentComp
            }
        </div>
    );
}

export default ContentDetails;

